import BaseProxy from './base.proxy';

class InvoiceProxy extends BaseProxy {
  invoices(query) {
    let queryString = new URLSearchParams(query).toString();
    return this.get(`/admin/invoice?${queryString}`);
  }
  invoicesPaging(query) {
    let queryString = new URLSearchParams(query).toString();
    return this.get(`/admin/invoice/paging?${queryString}`);
  }
  downloadZip(query) {
    let queryString = new URLSearchParams(query).toString();
    return this.download(`/admin/invoice/download-zip?${queryString}`);
  }
}
export default new InvoiceProxy();
